const PriceBRL = ({ value, cifrao=true }) => {
	let valueString = `${value}`;
	valueString = valueString.replace(/\D/g, "");
	var tmp = valueString.replace(/([0-9]{2})$/g, ",$1");
	if( tmp.length > 6 )
			tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
	
	if (cifrao) tmp = "R$ "+tmp;

	return tmp;

};

export default PriceBRL;
